<template>
	
	<v-progress-circular :size="50" :width="10" :value="value" :color="color" >
		{{ value }}
	</v-progress-circular>
</template>

<script type="text/javascript">
	export default {
		name: "ProgressCircle",
		props: {
			value: {type: Number}, 
			color: {type: String },
		}

	}
</script>